var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursesPage font-17"},[_c('topNav'),_c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12","cols":"12"}},[_c('CourseContent')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }